import { atom } from 'jotai';
import z from 'zod';

export const ZPaymentWalletsSchema = z.object({
  wallets: z.string().array(),
});

export type PaymentWalletsAtom = z.infer<typeof ZPaymentWalletsSchema>;

export const paymentWalletsAtom = atom<PaymentWalletsAtom>({
  wallets: [],
});
